  import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
  import { CurrencyConverterPurePipe } from 'app/shared/currency-converter-pure.pipe';


  interface TabItem {
    key: string;
    label: string;
    icon: string;
    type: string;
  }

  @Component({
    selector: 'usb-room-extras',
    templateUrl: './room-extras.component.html',
    styleUrls: ['./room-extras.component.scss'],
    providers: [CurrencyConverterPurePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
  })
  export class RoomExtrasComponent implements OnInit {

  @Input() roomExtras;
  @Input() selectedRooms;
  @Input() currencyAgency;
  @Input() currencies;
  @Input() buttonColorActive;
  @Input() arrivalDate: Date;
  @Input() extrasMap: Map<string, any[]> = new Map();  // Recibir del padre

  @Output() extrasChange = new EventEmitter();

  tabAddons: string = '';
  currentSlide: number = 0;
  itemsPerPage: number = 2; // Mostrar 2 tarjetas a la vez

  private selectedExtraPerRoom = new Map<string, string>();

    constructor() { }

    ngOnInit(): void {
      this.availableTabs;
      
    }

    get availableTabs(): TabItem[] {
    const tabs: TabItem[] = [];

    // Verificar qué tipos de extras existen en roomExtras
    if (this.roomExtras?.some(extra => extra.type === 'Transfer')) {
      tabs.push({
        key: 'transfer',
        label: 'Hotel + traslado',
        icon: '../../../../../assets/img/app/categories-search-box/bus.svg',
        type: 'Transfer'
      });
    }

    if (this.roomExtras?.some(extra => extra.type === 'Attractions')) {
      tabs.push({
        key: 'attractions',
        label: 'Hotel + Atracciones',
        icon: '../../../../../assets/icons/search-box/atracciones.svg',
        type: 'Attractions'
      });
    }

    if (this.roomExtras?.some(extra => extra.type === 'Hotel Supplements')) {
      tabs.push({
        key: 'Hotel Supplements',
        label: 'Hotel + sugerencias',
        icon: '../../../../../assets/icons/search-result/hotel/icono_sugerencias.svg',
        type: 'Hotel Supplements'
      });
    }

    // Si hay tabs, seleccionar el primero por defecto si no hay uno seleccionado
    if (tabs.length > 0 && !this.tabAddons) {
      this.tabAddons = tabs[0].key;
    }

    return tabs;
  }

// En el componente hijo (RoomExtrasComponent)
isRoomAvailableForExtra(room: any, extra: any, tabAddons: string): boolean {

  const extraType = this.getTypeByTab(tabAddons);
  const roomExtras = room?.service?.extras || [];
  
  // Verificar si la habitación tiene este extra disponible en su lista
  const hasExtra = roomExtras.some((e: any) => {
    if (e.type !== extraType) return false;
    
    if (e.options && e.options.length > 0) {
      return e.options.some((opt: any) => opt.optionid === extra.optionid);
    }
    return e.optionid === extra.optionid;
  });
  
  return hasExtra; 
}

// Obtener el tooltip/mensaje para habitación no disponible
getRoomAvailabilityMessage(room: any, extra: any, tabAddons: string): string {
  const isAvailable = this.isRoomAvailableForExtra(room, extra, tabAddons);
  if (!isAvailable) {
    return '(no disponible en habitación)';
  }
  return '';
}

    getTypeByTab(tab: string): string {
      const typeMap: { [key: string]: string } = {
        'transfer': 'Transfer',
        'attractions': 'Attractions',
        'Hotel Supplements': 'Hotel Supplements'
      };
      return typeMap[tab] || '';
    }


// ✅ Obtener habitaciones seleccionadas para un extra específico
// En RoomExtrasComponent
getSelectedRoomsForExtra(extra: any, tabAddons: string): any[] {
  const extraType = this.getTypeByTab(tabAddons);
  const selectedRoomsList: any[] = [];

  for (const room of this.selectedRooms) {
    const roomId = room._uniqueId;
    // ✅ Usar el mismo formato que en el padre (sin toLowerCase)
    const mapKey = `${roomId}_${tabAddons}`;  // ← Usar tabAddons directamente
    const roomExtras = this.extrasMap.get(mapKey) || [];

    if (roomExtras.some(e => e.optionid === extra.optionid)) {
      selectedRoomsList.push(room);
    }
  }

  return selectedRoomsList;
}

    onSelectionChangeExtras(event: any, extra: any, tabAddons: string): void {
      this.extrasChange.emit({action:event, extra: extra, tabAddons: tabAddons});
    };

    compareRooms(room1: any, room2: any): boolean {
    return room1?._uniqueId === room2?._uniqueId;
  }

      // Obtener las opciones del tipo de tab actual
    getCurrentOptions(): any[] {
      const extrasGroup = this.roomExtras?.find(
        (group: any) => group.type === this.getTypeByTab(this.tabAddons)
      );
      return extrasGroup?.options || [];
    }

    // Calcular total de páginas
    getTotalPages(): number {
      const totalItems = this.getCurrentOptions().length;
      return Math.ceil(totalItems / this.itemsPerPage);
    }

    // Siguiente slide
    nextSlide(): void {
      const maxSlide = (this.getTotalPages() - 1) * this.itemsPerPage;
      if (this.currentSlide < maxSlide) {
        this.currentSlide += this.itemsPerPage;
      }
    }

    // Slide anterior
    prevSlide(): void {
      if (this.currentSlide > 0) {
        this.currentSlide -= this.itemsPerPage;
      }
    }

    // Ir a slide específico
    goToSlide(slideIndex: number): void {
      this.currentSlide = slideIndex;
    }

    // Resetear slide cuando cambia el tab
    onTabChange(tab: string): void {
      this.tabAddons = tab;
      this.currentSlide = 0; // Resetear al primer slide
    }

  }
